
















































import { Vue, Component, Prop } from 'vue-property-decorator';
import PortalInput from "@/components/common/PortalInput.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import ServiceCatalogService from "@/services/ServiceCatalogService";
import ServiceCatalogItemDTO, { UpdateServiceCatalogPricePayload } from "@/dto/sales/catalog/ServiceCatalogItemDTO";
import { processError } from "@/utils/ComponentUtils";

@Component({
  components: { PortalInput, PortalDate }
})
export default class UpdateServiceCatalogPriceModal extends Vue {
  @Prop() item!: ServiceCatalogItemDTO;
  @Prop() onSuccess!: () => void;

  private priceDollars = '';
  private subscriberPriceDollars = '';
  private effectiveDateFrom = '';

  mounted() {
    if (this.item.actualPrice) {
      this.priceDollars = (this.item.actualPrice.priceCents / 100).toString();
      if (this.item.actualPrice.subscriberPriceCents !== null) {
        this.subscriberPriceDollars = (this.item.actualPrice.subscriberPriceCents / 100).toString();
      }
    }
  }

  get isFormValid(): boolean {
    const price = parseFloat(this.priceDollars);
    return !isNaN(price) && price >= 0;
  }

  async submit() {
    if ((this as any).$loadOn) (this as any).$loadOn();
    try {
      const payload: UpdateServiceCatalogPricePayload = {
        priceCents: Math.round(parseFloat(this.priceDollars) * 100),
        subscriberPriceCents: this.subscriberPriceDollars ? Math.round(parseFloat(this.subscriberPriceDollars) * 100) : null,
        effectiveDateFrom: this.effectiveDateFrom || null
      };

      await ServiceCatalogService.updatePrice(this.item.id, payload);
      if ((this as any).$nts) (this as any).$nts.success("Price updated successfully");
      if (this.onSuccess) this.onSuccess();
      this.close();
    } catch (e) {
      processError(e, this);
    } finally {
      if ((this as any).$loadOff) (this as any).$loadOff();
    }
  }

  close() {
    (this as any).$modal.hideAll();
  }
}
